/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { SentryRoute } from '../sentry-route';

const CustomRoute = (props) => {
  const {
    component: Component, isAuthenticated, isPublicRoute = false, location, ...rest
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <SentryRoute
      {...rest}
      render={(prop) => {
        if (isAuthenticated && !isPublicRoute) {
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: prop.location },
              }}
            />
          );
        }

        return <Component {...prop} />;
      }}
    />
  );
};

CustomRoute.defaultProps = {
  isPublicRoute: false,
};

CustomRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isPublicRoute: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  isAuthenticated: authentication.isAuthenticated,
});

export default connect(mapStateToProps, null)(CustomRoute);
